import classNames from 'classnames';
import React from 'react';
import ProgressCell from '@alfa-retail-react/components/progress-cell';
import './Step.less';

export type StepProps = {
    current: number;
    total: number;
    hint?: React.ReactElement;
    hideStep?: boolean;
    regularHint?: boolean;
};

export const Step = ({
    current,
    total,
    hint,
    hideStep,
    regularHint,
}: StepProps) => {
    const percent = () => (100 / total) * current;

    const stepTitle = (
        <span className="stepTitle">
            {!hideStep && `Шаг ${current} из ${total}${hint ? '.' : ''}`}
            {hint && (
                <span
                    className={classNames('stepHint', {
                        hideStep,
                        regularHint,
                    })}
                >
                    {hint}
                </span>
            )}
        </span>
    );

    return <ProgressCell value={percent()} upperLeft={stepTitle} />;
};
